<template>
	<div>
		<v-dialog v-model="dialog_required_fields" no-click-animation persistent transition="dialog-bottom-transition">
			<v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader style="display: flex;flex: 1;">Required Fields <v-spacer></v-spacer>
                        <v-btn icon @click="closeDialogWeb"><v-icon>close</v-icon></v-btn>
                    </v-subheader>
	        	</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height>
                    <!-- Generate E-Way bill JSON -->

					<div data-no-translate>
						<v-layout row wrap v-if="$parent.requiredFields && $parent.requiredFields.length">
							<v-flex xs12 sm12 md12 pt-3 v-for="(fieldName, index) in $parent.requiredFields" :key="index">
								<div class="mb-2" v-html="fieldName"></div>
							</v-flex>
						</v-layout>
					</div>

                    <v-alert type="warning" :value="true" class="mt-4">These fields are mandatory.</v-alert>
		        </v-card-text>
		        <!-- <v-divider></v-divider>
		        <v-card-actions>
                    <v-layout row wrap>
                        <v-flex xs6 sm6 md6 center-align style="border-right: 1px #ddd solid;">
                            <v-btn small color="blue darken-1" flat @click="$parent.fn_editEwayInvoice($parent.ewayBillDetailSection.sectionId)">Edit Details</v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 md6 center-align>
                            <v-btn small color="blue darken-1" flat @click="$parent.fn_downloadJSON($parent.ewayBillData, 'ewaybill')">Generate JSON</v-btn>
                        </v-flex>
                    </v-layout>
		        </v-card-actions> -->
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>

	export default{
		data(){
			return{
				dialog_required_fields:false,
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_required_fields = true;
			},
			closeDialogWeb: function () {
				this.dialog_required_fields = false;
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/dialogs/dialog_required_fields.vue